<template>
  <UserTable />
</template>

<script>
import UserTable from '@/components/UserTable.vue';

export default {
  components: {
    UserTable,
  },
};
</script>
